import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import clsx from "clsx";

import Icon from "@/components/atoms/media/Icon";
import Tooltip from "@/components/molecules/Tooltip";
import { ColorEnum, SizeEnum, TooltipPlacement } from "@/enums";
import { type CommonProps } from "@/types";
import { createId, formatCurrency } from "@/utils/helpers";

import styles from "./Price.module.css";

const ref = "price";

interface PriceProps extends Partial<CommonProps> {
  amount: number;
  baseline?: boolean;
  groupSize?: number;
}

function usePrice(props: PriceProps) {
  const className = clsx(styles[ref], props.className);
  const { amount = 0, baseline = false, id = createId(ref), groupSize } = props;

  return {
    amount: baseline ? Math.round(amount) : amount,
    baseline,
    className,
    id,
    groupSize,
  };
}

function Price(props: PriceProps) {
  const { amount, baseline, className, id, groupSize } = usePrice(props);
  const tooltipDescription = `Price per person based on ${groupSize ?? 2} sharing. Local fees may apply , confirmed at checkout`;

  return (
    <section className={className} id={id}>
      {baseline && <span>From</span>}
      <p>
        <span className={styles.amount}>{formatCurrency(amount)}</span>
        pp
        {groupSize != null && groupSize > 2 && (
          <Tooltip
            tooltip={tooltipDescription}
            placement={TooltipPlacement.BOTTOM_RIGHT}
            contentWidth={224}
            color={ColorEnum.NAVY}
            className="ml-2 text-sm"
          >
            <Icon
              color={ColorEnum.DARKERBLUE}
              name={faCircleInfo}
              noPadding
              size={SizeEnum.LARGE}
            />
          </Tooltip>
        )}
      </p>
    </section>
  );
}

export default Price;
export { Price, type PriceProps };
